export const HEADER_HEIGHT = '64px'
export const MAX_WIDTH = 500
export const MEDIA_QUERY = `( max-width: ${ MAX_WIDTH }px )`